// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading_loadingWrapper__2QAtN","logo":"loading_logo__3i7xH"};